import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import './style.sass';

type ChallengeType = {
    title: string;
    icon: string;
    description: string;
};

type ChallengePropsType = {
    list: ChallengeType[];
};

const Challenge = ({ list }: ChallengePropsType) => {
    return (
        <div className="aimed-chellenge-page">
            <FullWrapper className="aimed-chellenge-pageCase">
                <div className="aimed-chellenge-pageWrapper">
                    <div className="aimed-chellenge-pageMainTitle">Вызовы проекта</div>
                    <div className="aimed-chellenge-pageList">
                        {list &&
                            list.map(({ title, icon, description }) => {
                                return (
                                    <div className="aimed-chellenge-pageItem" key={title}>
                                        <div className="aimed-chellenge-pageIcon">
                                            <img src={icon} alt={title} />
                                        </div>
                                        <div
                                            className="aimed-chellenge-pageTitle"
                                            dangerouslySetInnerHTML={{ __html: title }}
                                        ></div>
                                        <div
                                            className="aimed-chellenge-pageDescription"
                                            dangerouslySetInnerHTML={{ __html: description }}
                                        ></div>
                                    </div>
                                );
                            })}
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Challenge;
